import type { StepProps } from "@mui/material";
import { Step } from "@mui/material";
import { styled } from "@mui/material/styles";

const SStep = styled((props: StepProps) => <Step {...props} />)(({ theme }) => ({
    "&.MuiStep-root": {
        "&.MuiStep-horizontal": {
            transition: "all ease-in-out 0.5s",
            maxWidth: "200px",
            borderRadius: "20px",
            padding: "5px",
            border: "1px solid #D9D9D9",
            ".MuiStepLabel-root": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                ".MuiStepLabel-labelContainer": {
                    transition: "all ease-in-out 0.5s",
                    transformOrigin: "0",
                    transform: "scaleX(1)",
                    whiteSpace: "nowrap",
                    marginRight: "8px",
                    ".MuiStepLabel-label": {
                        transition: "all ease-in-out 0.5s",
                        color: "#A7A7A7",
                        fontSize: "12px",
                        fontFamily: "Poppins",
                        "&.Mui-active": {
                            transition: "all ease-in-out 0.5s",
                            color: "black",
                            fontWeight: "600",
                        },
                    },
                },
                ".MuiStepLabel-iconContainer": {
                    ".MuiStepIcon-root": {
                        transition: "all ease-in-out 0.5s",
                        color: "#EAEAEA",
                        ".MuiStepIcon-text": {
                            transition: "all ease-in-out 0.5s",
                            fill: "#A7A7A7",
                            fontSize: "12px",
                        },
                        "&.Mui-active": {
                            transition: "all ease-in-out 0.5s",
                            color: "black",
                            ".MuiStepIcon-text": {
                                transition: "all ease-in-out 0.5s",
                                fill: "#fff",
                                fontWeight: "600",
                            },
                        },
                    },
                },
            },
        },
        "&.MuiStep-horizontal.resolved": {
            transition: "all ease-in-out 0.5s",
            maxWidth: "36px",
            borderColor: "#95D08B",
            ".MuiStepLabel-root": {
                ".MuiStepLabel-labelContainer": {
                    transition: "all ease-in-out 0.5s",
                    transform: "scaleX(0)",
                    ".MuiStepLabel-label": {
                        transition: "all ease-in-out 0.5s",
                        color: "#5DAD78",
                        translate: "tranx",
                    },
                },
                ".MuiStepLabel-iconContainer": {
                    ".MuiStepIcon-root": {
                        transition: "all ease-in-out 0.5s",
                        color: "#5DAD78",
                    },
                    ".MuiStepIcon-text": {
                        transition: "all ease-in-out 0.5s",
                        fill: "#FFFFFF!important",
                    },
                },
            },
        },
    },
}));

function StyledStep(props: Partial<StepProps>) {
    return <SStep {...props} />;
}

export default StyledStep;
